import $ from 'jquery'

let $grid;
let msnry;

export function initPostGrid() {
    $(document).ready(function () {

        $grid = $('.c-pub-postgrid__list.grid').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            gutter: 30,
            transitionDuration: '0.2s',
            // stagger: 30,
        });


        // get Masonry instance
        msnry = $grid.data('masonry');

    });


    $(window).on('load', function () {
        setListeners()
    });

}

export function masonryInit() {
    // return msnry;

    setTimeout(function () {

        //console.log("masonry INIT");
        $("body").removeClass("initMsnry");
        // $('.c-pub-postgrid__listitem').addClass('loaded');


        $grid = $('.c-pub-postgrid__list.grid').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            gutter: 30,
            transitionDuration: '0.2s',
            // stagger: 30,
        });

        msnry = $grid.data('masonry');
    }, 1000);
}


export function masonryUpdate() {

    setTimeout(function () {

        $grid.masonry();
    }, 10);

    setTimeout(function () {

        $("body").removeClass("initMsnry");
    }, 200);
}


function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        return uri + separator + key + "=" + value;
    }
}


export function getFilterAction(obj, fA = '') {

    let filterData = $(obj).data('filter');
    let filterDataValue = $(obj).data('filter-value');
    let parentChildren = $(obj).parent().children();
    let filterAction = $(obj).data('filter-action') || fA;


    const urlParams = new URLSearchParams(window.location.search);
    let oTCurrent = urlParams.get('oT');

    $("body").addClass("initMsnry");

    if (filterAction === 'update_dates') {

        $('.c-pub-postgrid__listitem').addClass('date_hidden');
        var list = document.getElementsByClassName("c-pub-postgrid__listitem");
        var i;

        for (i = 0; i < list.length; i++) {
            let listitem = list[i];

            let utc = $(listitem).attr('data-date');

            if (obj < (utc * 1000)) {

                $(listitem).removeClass('date_hidden');
            }



        }


        masonryUpdate()


    } else if (filterAction === 'update_terms') {

        $('.c-pub-postgrid__listitem').addClass('term_hidden');
        var list = document.getElementsByClassName("c-pub-postgrid__listitem");
        var i;
        let term;
        for (i = 0; i < list.length; i++) {
            let listitem = list[i];

            term = $(listitem).attr('data-term');

            if (obj === term || obj === "all") {

                $(listitem).removeClass('term_hidden');
            }
        }

// SHOW calender months
        $('.c-pub-postgrid__listitem.calendar-month[data-terms*="'+obj+'"]').removeClass('term_hidden');
        //console.log(obj);



        masonryUpdate()

    } else if (filterAction === 'reload') {

        setTimeout(function () {

            let uri = window.location.href;

            /**
             *
             *
             * ORDERING
             *
             *
             * **/

            var orderValue = $("div.c-pub-grid__filter").data("filter-order");
            var order = $("input[data-filter='order']:checked").val();
            let newOrderValue;

            if (order !== undefined) {
                // //console.log("newOrderValue",newOrderValue)
                if (oTCurrent === order) {
                    if (orderValue === 'asc') {
                        newOrderValue = 'desc'
                    } else if (orderValue === "desc") {
                        newOrderValue = 'asc'
                    }
                    uri = updateQueryStringParameter(uri, 'oV', newOrderValue);

                } else {
                    uri = updateQueryStringParameter(uri, 'oT', order);
                    // if (orderValue !== undefined) {
                    //     if (orderValue === 'asc') {
                    //         newOrderValue = 'desc'
                    //     } else if (orderValue === 'desc') {
                    //         newOrderValue = 'asc'
                    //     }
                    //     uri = updateQueryStringParameter(uri, 'oV', newOrderValue);
                    // } else {
                    //     // //console.log("OrderValue - Not SET!")
                    // }
                }

            } else {
                // //console.log("Order - Not SET!")
            }


            /**
             *
             *
             * FILTERS
             *
             *
             * **/


            var filter = $("select[data-filter='filter']").val();
            if (filter !== undefined) {

                //console.log(filter);
                if (filter !== 'all') {
                    uri = updateQueryStringParameter(uri, 'fV', filter);
                } else {
                    //console.log(filter);
                    uri = updateQueryStringParameter(uri, 'fV', filter);
                }


                // return;
            } else {
                //console.log("Filters - Not SET!")
            }


            /**
             *
             *
             * DISPLAY
             *
             *
             * **/


            var display = $("input[data-filter='display']:checked").val();
            if (display !== undefined) {
                uri = updateQueryStringParameter(uri, 'dV', display);
            } else {
                //console.log("Display - Not SET!")
            }

            //
            //

            location.href = uri;

        }, 0);


    } else {
        masonryUpdate()
    }


}

function setListeners() {
    $('.c-pub-postgrid__controls--item').on('click', function (event) {

        if (!$(this).hasClass('active')) {
            $('.c-pub-postgrid__controls--item').removeClass('active');
            $(this).addClass('active');


            const type = $(this).data('type');
            togglePostGrid(type)
        }
    });


    $('.c-pub-postgrid__header *.c-pub-grid__filter--option').on('click', function (event) {
        // //console.log(this);
        if (!$(this).hasClass('active')) {

            let filterData = $(this).data('filter');
            console.error($(this))

            let filterDataValue = $(this).data('filter-value');
            let parentChildren = $(this).parent().children();
            let filterAction = $(this).data('filter-action');

            // reload
            // //console.log(filterData);
            // //console.log(filterDataValue);
            // //console.log(parentChildren);

            var action = getFilterAction(this);
            // //console.log(action)


            // in case of radio & labels
            $(parentChildren).removeClass('active');
            $('.c-pub-postgrid__header *.c-pub-grid__filter--action[data-filter-value="' + filterDataValue + '"').addClass("active");

            // in case of select?
            let type = $(this).data('type');
            if (type == undefined) {
                type = $(this).val()
            }

            if (filterAction !== 'reload') {
                togglePostGrid(filterData, filterDataValue)

            }
        }
    })


}

function togglePostGrid(filterData, filterDataValue) {

    // //console.log(type)
    if (filterData && filterDataValue) {
        // //console.log("Toggle PostGrid!!")

        if (filterData === "display") {
            // //console.log("Toggle PostGrid!!");
            removePostGridClass('view');
            $('.archive-list').addClass(filterDataValue)
        }

        //
        // $('.archive-list').removeClass('view-list')
        // $('.archive-list').removeClass('view-detail')
        // $('.archive-list').removeClass('view-grid')
        // $('.archive-list').addClass(filterDataValue)

    }

}

function removePostGridClass(string) {
    if (string) {
        $(".archive-list").removeClass(function (index, css) {
            return (css.match(/\bview\S+/g) || []).join(' '); // removes anything that starts with "itemnx"
        });
    }
}

// export default {initPostGrid: initPostGrid, getFilterAction: getFilterAction}


